module.exports = __webpack_public_path__ + "media/journey1-C.6b79bb87.mp4";